module.exports = __webpack_public_path__ + "109c43b079eb84759409fab762518f12.svg";